// Permissions composable — provides global reactive permission state.
// Uses Nuxt's useState for SSR-safe global sharing (no Pinia needed).
// Permissions are fetched from the API after login and stored here + localStorage.

const STORAGE_KEY = 'user_permissions'

function getHeaders() {
  const token = localStorage.getItem('access_token') ?? ''
  const organizationId = localStorage.getItem('organization_id') ?? ''
  return {
    'Authorization': `Bearer ${token}`,
    'X-Organization-Id': organizationId
  }
}

export function usePermissions() {
  const permissions = useState<string[]>('permissions', () => {
    if (import.meta.client) {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? '[]') as string[]
      } catch {
        return []
      }
    }
    return []
  })

  async function fetchPermissions(): Promise<void> {
    try {
      const data = await $fetch<{ permissions: string[] }>('/api/users/me/permissions', {
        headers: getHeaders()
      })
      permissions.value = data.permissions
      localStorage.setItem(STORAGE_KEY, JSON.stringify(data.permissions))
    } catch {
      permissions.value = []
      localStorage.removeItem(STORAGE_KEY)
    }
  }

  function hasPermission(key: string): boolean {
    return permissions.value.includes(key)
  }

  function clearPermissions(): void {
    permissions.value = []
    localStorage.removeItem(STORAGE_KEY)
  }

  return { permissions, fetchPermissions, hasPermission, clearPermissions }
}
